import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import clsx from 'clsx';
import Pagination from '@components/catalog/pagination/pagination';
import MobilePagination from '@components/catalog/pagination/mobile-pagination/mobile-pagination';
import styles from './product-search/product-search.module.scss';

const BottomPaginationSection: React.FC = (): React.JSX.Element => {
  const pageCount = useContextSelector(CatalogContext, (v) => v.pageCount);
  const currentPage = useContextSelector(CatalogContext, (v) => v.currentPage);
  const queryResult = useContextSelector(CatalogContext, (v) => v.queryResult);
  const updateCurrentPage = useContextSelector(CatalogContext, (v) => v.updateCurrentPage);
  const products = useContextSelector(CatalogContext, (v) => v.products);

  return (
    <>
      <div className={styles.catalog__pagination__mobileContainer}>
        <MobilePagination
          handleNext={() => updateCurrentPage(currentPage + 1, true)}
          handlePrevious={() => updateCurrentPage(currentPage - 1, true)}
          currentPage={currentPage}
          pageCount={queryResult?.paginationStats?.totalPages || currentPage}
          showScrollTop={products.length > 4}
        />
      </div>
      <div className={clsx(styles.catalog__pagination, styles['catalog__pagination--lower'])}>
        <Pagination
          behaviour="catalog"
          currentPage={currentPage}
          pageCount={pageCount}
          showText={true}
          hasArrows={true}
          onChange={(page) => updateCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default BottomPaginationSection;
